import { DailyrentLayout } from '../../components/DailyrentLayout';
import { DailyrentHeaderContainer } from '../DailyrentHeaderContainer';
import { AggregatedScoresContainer } from '../AggregatedScoresContainer';
import { DailyrentReviewsHeaderContainer } from '../DailyrentReviewsHeaderContainer';
import { DailyrentReviewsListContainer } from '../DailyrentReviewsListContainer';
import { ReviewsFixedFooterLayout } from '../../components/ReviewsLayout';

export const DailyrentPageContainer = () => {
  return (
    <DailyrentLayout
      header={<DailyrentHeaderContainer />}
      topContent={<AggregatedScoresContainer />}
      columnContent={
        <>
          <DailyrentReviewsHeaderContainer />
          <DailyrentReviewsListContainer />
        </>
      }
      sidebar={<ReviewsFixedFooterLayout review={null} moderation={null} question={null} />}
    />
  );
};
